/* Moove caixa fechada â category qty fallbacks (Fabio 2026-10) */
(function () {
  var CAIXA_POR_CATEGORIA = {
    cabos: 600,
    carregador: 200,
    fone: 100,
    powerbank: 60,
  };

  function detectCategory(root) {
    var fromData = (root.getAttribute('data-moove-categoria') || '').toLowerCase();
    if (fromData && CAIXA_POR_CATEGORIA[fromData]) return fromData;
    var blob = (
      (root.getAttribute('data-product-title') || '') +
      ' ' +
      (root.getAttribute('data-product-type') || '') +
      ' ' +
      (document.title || '')
    ).toLowerCase();
    if (/power\s*bank|powerbank|carregador port[aÃ¡]til/.test(blob)) return 'powerbank';
    if (/microfone|lapela/.test(blob)) return '';
    if (/\bfone\b|earbud|headset|headphone|earphone|\btws\b/.test(blob)) return 'fone';
    if (/carregador|charger|adaptador|fonte|gan\s*\d|wall charger|plug/.test(blob)) return 'carregador';
    if (/\bcabo\b|cable/.test(blob)) return 'cabos';
    return '';
  }

  function money(cents) {
    try {
      if (window.Shopify && Shopify.formatMoney)
        return Shopify.formatMoney(
          cents,
          (window.themeVariables && themeVariables.moneyFormat) ||
            (window.theme && theme.moneyFormat) ||
            '{{amount}}'
        );
    } catch (e) {}
    return 'R$ ' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function init() {
    var root = document.querySelector('[data-moove-caixa]');
    if (!root || root.getAttribute('data-moove-ready')) return;
    root.setAttribute('data-moove-ready', '1');

    var boxQty = parseInt(root.getAttribute('data-unidades-caixa') || '0', 10) || 0;
    if (!boxQty) {
      var cat = detectCategory(root);
      if (cat && CAIXA_POR_CATEGORIA[cat]) {
        boxQty = CAIXA_POR_CATEGORIA[cat];
        root.setAttribute('data-unidades-caixa', String(boxQty));
        root.setAttribute('data-moove-categoria', cat);
      }
    }

    var unitCents = parseInt(root.getAttribute('data-preco-unidade') || '0', 10) || 0;
    var boxCents = parseInt(root.getAttribute('data-preco-caixa') || '0', 10) || 0;
    // If box price missing but we have unit cost basis via unit price and markup rules:
    // fracionado = custo*1.15, caixa = custo*qty*1.10 => box = unit/1.15*qty*1.10
    if (!boxCents && unitCents && boxQty > 0) {
      var costCents = Math.round(unitCents / 1.15);
      boxCents = Math.round(costCents * boxQty * 1.1);
      root.setAttribute('data-preco-caixa', String(boxCents));
    }

    var qtyInput = document.querySelector('input[name="quantity"], #number');
    var info = document.getElementById('moove-caixa-info');

    function selectedVariantLabel() {
      var checked = document.querySelector(
        '.product-form__single-selector:checked, .block-swatch__radio:checked, input[type=radio][name*=option]:checked'
      );
      if (checked) return (checked.value || checked.getAttribute('value') || '').toLowerCase();
      var sel = document.querySelector('select.product-form__single-selector, select[name*=option]');
      if (sel) return (sel.value || '').toLowerCase();
      var active = document.querySelector('.variantes .options.is-active, .variantes .options.active');
      if (active) return (active.textContent || '').toLowerCase();
      return '';
    }
    function isCaixa() {
      return selectedVariantLabel().indexOf('caixa') !== -1;
    }
    function update() {
      if (!boxQty) return;
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      var caixaMode = isCaixa() || qty >= boxQty;
      if (info) {
        info.style.display = 'block';
        if (caixaMode) {
          info.innerHTML =
            '<strong>Caixa fechada:</strong> ' +
            boxQty +
            ' unidades' +
            (boxCents ? ' â total ' + money(boxCents) : '') +
            (unitCents && boxCents
              ? ' <span style="opacity:.75">(equiv. ' + money(Math.round(boxCents / boxQty)) + '/un)</span>'
              : '');
        } else {
          info.innerHTML = '';
          info.style.display = 'none';
        }
      }
    }

    document.querySelectorAll('.variantes .options').forEach(function (opt) {
      opt.addEventListener('click', function () {
        document.querySelectorAll('.variantes .options').forEach(function (o) {
          o.classList.remove('is-active');
        });
        opt.classList.add('is-active');
        var hid = opt.querySelector('.iddavariante');
        var idInput = document.querySelector('input[name="id"]');
        if (hid && idInput) idInput.value = hid.getAttribute('val');
        update();
        if (typeof $ !== 'undefined') $(document).trigger('variant:changed');
      });
    });

    if (qtyInput) {
      qtyInput.addEventListener('change', update);
      qtyInput.addEventListener('input', update);
    }
    document.addEventListener('change', function (e) {
      if (e.target && (e.target.matches('.product-form__single-selector') || e.target.name === 'quantity')) update();
    });
    update();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
